@if (runData) {
    <div class="row">
        <div class="col-md-6">
            <h4>{{ teamLeaderLabel$ | async }}</h4>
            <div class="d-flex align-items-center mb-3">
                @if (runData.team.teamLeaderPerson) {
                    <adapt-link-person [person]="runData.team.teamLeaderPerson"
                                       [showImage]="true"
                                       [linkDisabled]="true"></adapt-link-person>
                } @else {
                    <span>No {{ (teamLeaderLabel$ | async)?.toLocaleLowerCase() }} assigned</span>
                }
            </div>

            <h4>{{ teamMembersLabel$ | async }}</h4>
            <adapt-select-person #selectTeamMember
                                 (personChange)="onTeamMemberPersonChange($event)"
                                 [filter]="filterAvailable"
                                 [disabled]="submitting"
                                 data-test="select-team-member"></adapt-select-person>
            @if (this.runData.createTeamBindingModel.memberPersonIds.length > 0) {
                <dx-list [dataSource]="this.runData.createTeamBindingModel.memberPersonIds"
                         [allowItemDeleting]="true"
                         [activeStateEnabled]="false"
                         [focusStateEnabled]="false"
                         [hoverStateEnabled]="false"
                         [disabled]="submitting"
                         (onItemDeleted)="removeMember($event)"
                         class="dx-list-boxed h-auto"
                         data-test="team-members-list">
                    <div *dxTemplate="let data of 'item'">
                        @if (data) {
                            <adapt-link-person [personId]="data"
                                               [showImage]="true"
                                               [linkDisabled]="true"
                                               imageSize="sm"></adapt-link-person>
                        }
                    </div>
                </dx-list>
            } @else {
                <div class="text-muted my-3"
                     data-test="team-members-list">No {{ (teamMembersLabel$ | async)?.toLocaleLowerCase() }} added.</div>
            }
        </div>
    </div>
}

<ng-template #createTeamButton>
    <adapt-add-team-create-team-button [instance]="this"></adapt-add-team-create-team-button>
</ng-template>
